import { defineComponent } from 'vue';
import { GameState, RoomStatusMessageCode } from '@/types/rooms';
import useRooms from '@/compositions/useRooms';
import { MessageBar } from '@/components/Widgets';
import RoomLaser from './RoomLaser';
import RoomLaserCross from './RoomLaserCross';
import RoomKeypad from './RoomKeypad';
import RoomReaction from './RoomReaction';
import RoomScore from './RoomScore';
import RoomCamera from './RoomCamera';
import RoomCombination from './RoomCombination';
import RoomSearch from './RoomSearch';
import RoomCatapult from './RoomCatapult';
import RoomArcade from './RoomArcade';
import RoomSpiderweb from './RoomSpiderweb';
import RoomRepeat from './RoomRepeat';
import RoomJungle from './RoomJungle';
import RoomGrid from './RoomGrid';
export default defineComponent({
    name: 'Room',
    title: 'Beat Out!',
    components: {
        RoomLaser,
        RoomScore,
        RoomKeypad,
        RoomCamera,
        RoomReaction,
        RoomCombination,
        RoomSearch,
        RoomCatapult,
        MessageBar,
        RoomArcade,
        RoomSpiderweb,
        RoomRepeat,
        RoomJungle,
        RoomGrid,
        RoomLaserCross
    },
    props: {
        roomid: {
            type: String,
            required: true
        }
    },
    computed: {
        gameType() {
            return this.$store.direct.state.rooms.type;
        },
        gameState() {
            const gamestate = this.$store.direct.state.rooms.gameState;
            if (gamestate === GameState.Demo)
                return GameState.Playing;
            return gamestate;
        },
        isDemo() {
            return this.$store.direct.state.rooms.gameState === GameState.Demo;
        },
        config() {
            return this.$store.direct.state.rooms.config[this.roomid];
        },
        status() {
            return this.$store.direct.state.rooms.status[this.roomid];
        },
        message() {
            var _a, _b, _c, _d;
            // Should be refactored to be 'schedule messages'
            if (((_a = this.status) === null || _a === void 0 ? void 0 : _a.state) === GameState.Playing
                && ['INFO', 'WARNING', 'DANGER'].includes((_c = (_b = this.status) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.code))
                return undefined;
            if (this.status === undefined)
                return undefined;
            if (this.status.message.timer < 1)
                return undefined;
            const time = Math.floor(this.status.message.timer);
            if (this.status.message.code === 'info') {
                return this.status.message.message;
            }
            if (this.status.message.code === RoomStatusMessageCode.WRONG_ROOM) {
                let currentRoomName = useRooms().roomNameFromId(this.status.message.message);
                if (!currentRoomName) {
                    currentRoomName = 'KokiBar';
                }
                return `Welkom! Helaas ben je in de verkeerde kamer, ga naar de ${currentRoomName}.`;
            }
            if (((_d = this.status) === null || _d === void 0 ? void 0 : _d.state) === GameState.Stopped) {
                return `Je kan deze kamer spelen over ${time} seconden. Badge dan opnieuw.`;
            }
            return '';
        },
        name() {
            return (this.config && this.config.name) || 'Loading...';
        }
    },
    mounted() {
        this.$store.direct.dispatch.rooms.subscribeStatus(this.roomid);
        this.$store.direct.dispatch.rooms.subscribeRoomActions(this.onEvent);
    },
    destroyed() {
        this.$store.direct.dispatch.rooms.unsubscribeStatus(this.roomid);
        this.$store.direct.dispatch.rooms.unsubscribe(this.roomid);
        // TODO unsubscribe subscribeRoomActions
    },
    methods: {
        onEvent(type, data) {
            try {
                // @ts-ignore   TODO fix
                this.$refs.room.onEvent(type, data);
            }
            catch (error) {
                console.log('Room has errors handling onEvent', error);
            }
        }
    }
});
